import * as User from '../../constants/User/MyPage'
import { getMyCircle } from './CircleList'
import { communityDestroy, communityDestroyFlagRemove, communityAllReset } from '../Community'

export function getMyCircleList(userId) {
  return dispatch => {
    dispatch(getMyCircle(userId))
    dispatch(communityAllReset())
    return {
      type: User.GET_MY_CIRCLE_LIST_IN_MY_PAGE
    }
  }
}

export function communityDestroyInMyPage(userId) {
  return dispatch => {
    dispatch(communityDestroy(userId))
  }
}

export function communityDestroyFlagRemoveInMyPage() {
  return dispatch => {
    dispatch(communityDestroyFlagRemove())
  }
}


// WEBPACK FOOTER //
// ./src/actions/User/MyPage.js